// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cef370e5","667":"dbe23964"}[chunkId] + ".chunk.js";
};